export default __webpack_public_path__ + "static/media/leave-lg-2.d7c43f40.png";